import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import {
  WEB_COMPONENT_GRID_VIEW,
  WEB_COMPONENT_GZ_SIDE_MENU,
  WEB_COMPONENT_GZ_TITLE,
} from '../../../webcomponents.constants';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { Column, ColumnKeys } from '../types';
import { Task } from '../../networkTasks/types';
import { GridViewWebComponent } from '../../../grid/gridView';
import { GridConfig } from './GridConfig';
import { GridViewMetadata, ViewConfiguration, ViewType } from '../../../grid/gridView/types';
import { SubTasksGridDataProvider } from '../dataProvider/SubTasksGridDataProvider';
import { GzSideMenuWebComponent } from '../../../ui/gzSideMenu';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { ElementClass, elementClassListAdd, elementClassListRemove } from '../../../utils/htmlElement.utils';
import { TaskType } from '../../networkTasks/types';

export class SubTasksView extends BaseWebComponentView {
  public dom: {
    $hostElement: HTMLElement;
    $title: GzTitleWebComponent;
    $grid: GridViewWebComponent<Column, ColumnKeys>;
    $sideMenu: GzSideMenuWebComponent;
    $stopBtn: GzButtonWebComponent;
    $btnBack: HTMLElement;
    $btnBackText: HTMLElement;
  };

  private task?: Task;

  public getDomElements(): void {
    this.dom.$title = this.shadow.querySelector(WEB_COMPONENT_GZ_TITLE);
    this.dom.$grid = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW);
    this.dom.$sideMenu = this.shadow.querySelector(WEB_COMPONENT_GZ_SIDE_MENU);
    this.dom.$stopBtn = this.shadow.querySelector('#stopBtn');
    this.dom.$btnBack = this.shadow.querySelector('#btnBack');
    this.dom.$btnBackText = this.shadow.querySelector('#btnBackText');

    this.getTranslations();
  }

  async buildView(data) {
    if (!this.shadow.host.task) {
      return;
    }

    this.dom.$sideMenu.closeSideMenu();
    this.dom.$sideMenu.setMenuContent(null);
    this.task = this.shadow.host.task;
    this.dependencies.task = this.task;
    const { viewMetaData } = new GridConfig().getDataForView(this.dependencies);
    this.buildGrid(viewMetaData);
    this.setTranslations();
    this.setStopButton();
  }

  private buildGrid(viewMetaData: GridViewMetadata<Column, ColumnKeys>): void {
    const grid: GridViewWebComponent<Column, ColumnKeys> = this.dom.$grid;
    const defaultViewProps: ViewConfiguration<Column, ColumnKeys> = {
      compactView: viewMetaData.isCompactViewChecked,
      displayedColumns: viewMetaData.columns,
      filters: viewMetaData.filters,
      name: '',
      pageSize: viewMetaData.pageSize,
      type: ViewType.DEFAULT,
      id: viewMetaData.viewId,
    };
    grid.propertiesSet = false;
    grid.dataProvider = new SubTasksGridDataProvider(this.dependencies);
    grid.sideMenuParent = this.dom.$hostElement;

    for (const [key, value] of Object.entries(viewMetaData)) {
      grid[key] = value;
    }
    grid.defaultViewProps = defaultViewProps;
    grid.propertiesSet = true;
    grid.injectDependencies(this.dependencies);
    grid.start().catch(console.error);
  }

  private setStopButton(): void {
    if (
      this.task?.type === TaskType.TASK_TYPE_SCAN_PARENT ||
      this.task?.type === TaskType.TASK_TYPE_SCAN_EXCHANGE_PARENT
    ) {
      elementClassListRemove(this.dom.$stopBtn, ElementClass.HIDDEN);
    } else {
      elementClassListAdd(this.dom.$stopBtn, ElementClass.HIDDEN);
    }
  }

  private setTranslations(): void {
    this.dom.$title.textContent = this.dependencies.translateFn('Subtasks of {TASK_NAME}', {
      TASK_NAME: this.task?.name,
    });
    this.dom.$stopBtn.textContent = this.dependencies.translateFn('STOP');
    this.dom.$btnBackText.textContent = this.dependencies.translateFn('Back');
  }

  getTranslations() {
    this.translations = {
      common: this.stringsTranslator.getCommonStrings(),
    };
  }

  get allTranslations() {
    return this.translations;
  }

  public getStopConfirmationDialogFooterHtml(): string {
    return `
      <gz-button id='confirm' color='primary' class='mr-2'>
        ${this.dependencies.translateFn('STOP')}
      </gz-button>
      <gz-button id='cancel' type='outline' color='secondary'>
        ${this.dependencies.translateFn('CANCEL')}
      </gz-button>
    `;
  }
}
